import React from "react";
import { ButtonProps } from "./Button.types";
import { useClassNames } from "../../../structure";
import { adjustColor } from "../../../structure/layout/style/lib";
import { Icon } from "../../basic/icon";
import { Loader } from "../../basic/loader";

export default function Button({
  title,
  children,
  classNames,
  left,
  right,
  isLoading,
  type,
  onBlur,
  disabled,
  onFocus,
  onPress,
}: ButtonProps) {
  const style = useClassNames(
    classNames
      ? ["btn", "btnPrimary", "btnMedium", ...classNames]
      : ["btn", "btnPrimary", "btnMedium", disabled ? "btnDisabled" : ""]
  );
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <button
      type={type}
      disabled={disabled}
      onBlur={onBlur}
      onFocus={onFocus}
      onMouseOver={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
      onClick={onPress}
      style={{
        all: "unset",
        ...style,
        cursor: disabled ? "not-allowed" : "pointer",
        backgroundColor:
          isHovered && !disabled && !isLoading
            ? adjustColor(
                style?.backgroundColor && style.backgroundColor !== "transparent"
                  ? style?.backgroundColor
                  : style?.color || "transparent",
                0.9,
                style?.backgroundColor && style.backgroundColor !== "transparent" ? 1 : 0.05
              )
            : style?.backgroundColor || style?.color || "transparent",
        position: "relative",
        color: isLoading ? "transparent" : style?.color,
        display: "flex",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: `50%`,
          width: "0px",
          height: "0px",
          top: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader color={style.color} size={style.fontSize as number} isLoading={!!isLoading} />
      </div>
      {left ? (
        <Icon color={isLoading ? "transparent" : style?.color} size={style.fontSize as number} {...left} />
      ) : null}
      {title ? title : children}
      {right ? (
        <Icon color={isLoading ? "transparent" : style?.color} size={style.fontSize as number} {...right} />
      ) : null}
    </button>
  );
}
